interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-24 px-5 rounded-lg bg-background-100 border border-dashed border-background-300">
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-background-200 text-foreground-400 mb-5">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 max-w-sm leading-relaxed mb-6">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-accent-500 text-primary-950 hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}